<template>
  <div>
      <!--搜索-->
    <div class="up-search-box middle-box" :class="{ active: showSearch }" @click.self="closeSearch">
      <div class="middle-cont" @click.stop>
        <div class="search-box search-mobile x-show">
          <form @submit.prevent="handleSearch">
            <input
              type="text"
              class="s-inp"
              v-model="searchKeyword"
              @keydown.esc.prevent="closeSearch"
              placeholder="请输入搜索内容"
            >
            <input type="submit" class="s-btn" value="确定">
          </form>
        </div>
      </div>
    </div>
      <!--头部-->
      <div class="head">
        <div class="banner">
          <img :src="bannerImage"/>
        </div>
        <!-- 导航栏 -->
        <div class="nav-wrap">
          <div class="container">
            <div class="login-box">
              <a href="javascript:;" class="first" @click="$router.push({ path: '/login'})">门户登录</a>
            </div>
          </div>
          <div class="navbar" :class="{ 'navbar-fixed': isFixed, open: menuOpen }">
            <div class="navbar-header">
                <a href="/" class="header-logo" @mousemove="handleLogoGlow" @mouseleave="resetLogoGlow">
                  <img src="@/assets/jadelab.png" alt="" />
                </a>
            </div>
            <div class="header-right">
                <div class="navbar-collapse" id="navbar-menu">
                  <ul class="navbar-nav">
                    <li :class="{ active: $route.path === '/' || $route.path === '/search'}" @click="$router.push('/')"><a href="javascript:;">首页</a></li>
                    <li :class="{ active: $route.path === '/overview?subtitle=sysgk' }" @click="$router.push({ path: '/overview', query: { subtitle: 'sysgk' } })">
                      <a
                        href="javascript:;"
                        class="dropdown-toggle"
                        data-toggle="dropdown"
                        >实验室概况</a
                      >
                      <ul class="dropdown-menu">
                      </ul>
                    </li>
                    <li :class="{ active: $route.path === '/alumnus' }" @click="$router.push({ path: '/alumnus', query: { subtitle: 'sztd' } })">
                      <a
                        href="javascript:;"
                        class="dropdown-toggle"
                        data-toggle="dropdown"
                        >师资队伍</a
                      >
                      <ul class="dropdown-menu"></ul>
                    </li>
                    <li :class="{ active: $route.path === '/dynamic' || $route.path === '/dynamic/news' }" @click="$router.push({ path: '/dynamic', query: { subtitle: 'sysdt2' } })">
                      <a
                        href="javascript:;"
                        class="dropdown-toggle"
                        data-toggle="dropdown"
                        >实验室动态</a
                      >
                      <ul class="dropdown-menu"></ul>
                    </li>
                    <li class="has-sub" :class="{ active: $route.path === '/research', expanded: expandedMenu === 'research' }" @click="onParentMenu('research', { path: '/research', query: { subtitle: 'kxyj' } })">
                      <a
                        href="javascript:;"
                        class="dropdown-toggle"
                        data-toggle="dropdown"
                        >科学研究</a
                      >
                      <ul class="dropdown-menu">
                        <li class="dropdown"  @click.stop="$router.push({ path: '/research', query: { type: 'yjfx', subtitle: 'kxyj'  } })">
                          <a
                            href="javascript:;"
                            class="dropdown-toggle"
                            data-toggle="dropdown"
                            >研究方向</a
                          >
                        </li>
                        <li class="dropdown"  @click.stop="$router.push({ path: '/research', query: { type: 'kyxm', subtitle: 'kxyj'  } })">
                          <a
                            href="javascript:;"
                            class="dropdown-toggle"
                            data-toggle="dropdown"
                            >科研项目</a
                          >
                        </li>
                        <li class="dropdown"  @click.stop="$router.push({ path: '/research', query: { type: 'xscg', subtitle: 'kxyj'  } })">
                          <a
                            href="javascript:;"
                            class="dropdown-toggle"
                            data-toggle="dropdown"
                            >学术成果</a
                          >
                        </li>
                        <li class="dropdown"  @click.stop="$router.push({ path: '/research', query: { type: 'ryjx', subtitle: 'kxyj'  } })">
                          <a
                            href="javascript:;"
                            class="dropdown-toggle"
                            data-toggle="dropdown"
                            >荣誉奖项</a
                          >
                        </li>
                      </ul>
                    </li>
<!--                     <li :class="{ active: $route.path === '/platform' }" @click="$router.push({ path: '/platform', query: { subtitle: 'kypt' } })">
                      <a
                        href="javascript:;"
                        class="dropdown-toggle"
                        data-toggle="dropdown"
                        >成果转化</a
                      >
                      <ul class="dropdown-menu"></ul>
                    </li> -->
                    <li :class="{ active: $route.path === '/student' }" @click="$router.push({ path: '/student', query: { subtitle: 'xsfc' } })">
                      <a
                        href="javascript:;"
                        class="dropdown-toggle"
                        data-toggle="dropdown"
                        >学生风采</a
                      >
                      <ul class="dropdown-menu"></ul>
                    </li>
                    <li :class="{ active: $route.path === '/graduate' }" @click="$router.push({ path: '/graduate', query: { subtitle: 'zsxx' } })">
                      <a
                        href="javascript:;"
                        class="dropdown-toggle"
                        data-toggle="dropdown"
                        >招生信息</a
                      >
                      <ul class="dropdown-menu"></ul>
                    </li>
                  </ul>
                </div>

                <div class="search-trigger" @click="toggleSearch"></div>

                <a class="toggle" @click="toggleMenu">
                  <span></span>
                </a>
            </div>
          </div>
        </div>
<!--         <div class="title">
            <p>突破型、引领型、平台型一体化的国家级实验室</p>
        </div> -->
      </div>
  </div>
</template>

<script>
import { getBanner } from '@/api/banner.js'

export default {
  name: 'headIndex',
  data () {
    return {
      bannerImage: '',
      isFixed: true,
      scrollThreshold: 28,
      showSearch: false,
      searchKeyword: '',
      menuOpen: false,
      expandedMenu: ''
    }
  },
  mounted () {
    this.getBannerData('zjsys')
  },
  watch: {
    $route () {
      this.menuOpen = false
      this.expandedMenu = ''
    }
  },
  methods: {
    async getBannerData (subtitle) {
      try {
        const res = await getBanner(subtitle)
        if (res?.data?.imageUrl) {
          this.bannerImage = this.$baseUrl + res.data.imageUrl
        }
      } catch (err) {
        console.error('获取banner失败：', err)
      }
    },
    handleScroll () {
      this.isFixed = true
    },
    handleLogoGlow (event) {
      const el = event.currentTarget
      const rect = el.getBoundingClientRect()
      el.style.setProperty('--logo-glow-x', `${event.clientX - rect.left}px`)
      el.style.setProperty('--logo-glow-y', `${event.clientY - rect.top}px`)
      el.style.setProperty('--logo-glow-opacity', '1')
    },
    resetLogoGlow (event) {
      const el = event.currentTarget
      el.style.setProperty('--logo-glow-opacity', '0')
    },
    toggleSearch () {
      this.showSearch = !this.showSearch
    },
    toggleMenu () {
      this.menuOpen = !this.menuOpen
    },
    onParentMenu (key, route) {
      // 移动端：点击父级菜单只展开/收起子项，不跳转
      if (window.innerWidth <= 768) {
        this.expandedMenu = this.expandedMenu === key ? '' : key
        return
      }
      // 桌面端：保持原有的点击跳转行为
      this.$router.push(route)
    },
    closeSearch () {
      this.showSearch = false
      this.searchKeyword = ''
    },
    handleSearch () {
      const keyword = this.searchKeyword.trim()
      if (!keyword) {
        alert('请输入关键词后再进行提交')
        return
      }

      // 跳转到搜索页面，携带 keyword
      this.$router.push({
        path: '/search',
        query: {
          subtitle: 'kypt',
          keyword: keyword
        }
      })

      // 关闭搜索框
      this.showSearch = false
      this.searchKeyword = ''
    }
  }
}
</script>

<style lang="less">
.up-search-box {
    position: fixed;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    transform: scale(1.2);
    opacity: 0;
    z-index: -1;
    background: rgba(5, 32, 58, 0.72);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    padding: 13.25px;
    transition: 0.3s;
    font-size: 0;
    letter-spacing: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    &.active {
        transform: scale(1);
        opacity: 1;
        z-index: 99999;
    }
    .middle-cont {
        width: 100%;
        display: inline-block;
        vertical-align: middle;
        font-size: 14px;
        letter-spacing: 0;
        .search-box {
            position: relative;
            max-width: 662.5px;
            margin-left: auto;
            margin-right: auto;
            background: rgba(234, 237, 250, 0.95);
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 24px;
            overflow: hidden;
            form input{
                font: inherit;
                outline: 0;
                border: 0;
                background: none;
                color: inherit;
            }
            .s-inp {
                width: 100%;
                height: 44px;
                line-height: 44px;
                font-size: 14px;
                padding-left: 20px;
                padding-right: 50px;
                color: #333;
                &::placeholder {
                    color: #999;
                }
            }
            .s-btn {
                height: 44px;
                width: 44px;
                position: absolute;
                top: 0px;
                right: 0px;
                padding: 0;
                border: none;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                z-index: 9;
                font-size: 14px;
                color: rgba(255, 255, 255, 0.85);
                transition: color 0.25s;
                &:hover {
                    color: #fff;
                }
            }
        }
    }
}
.head {
  height:auto;
  min-height: 0;
  position:relative;
  background: #062845;
  .banner {
    position: relative;
    z-index: 1;
    padding-top: 70px;
    overflow: hidden;
    background: #062845;
  }
  .banner > img {
  position: static;
  display: block;
  height:auto;
  width:100%;
  object-fit: contain;
  object-position: center center;
  z-index: 1;
  border-radius: 0;
  }
  .nav-wrap{
    position:absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 2147483000;
    padding:0;
    .container{
      padding:0 106px;
      .login-box{
        float:right;
        display: flex;
        align-items: center;
        gap: 14px;
        a{
          font-size: 12px;
          color: rgba(255, 255, 255, 0.85);
          line-height: 1;
          letter-spacing: 0.02em;
          transition: color 0.25s;
          &:hover {
            color: #fff;
          }
        }
        .first{
          padding-right: 14px;
          border-right: 1px solid rgba(255,255,255,.35);
        }
      }
    }
    .navbar{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 106px;
      min-height: 64px;
      width:100%;
      background: rgba(5, 32, 58, 0.72);
      border: 1px solid rgba(255, 255, 255, 0.14);
      border-top: 0;
      border-radius: 0 0 18px 18px;
      transition: all 0.35s cubic-bezier(0.25, 0.1, 0.25, 1);
      &.navbar-fixed {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 2147483001;
        background: rgba(5, 32, 58, 0.72) !important;
        border: 1px solid rgba(255, 255, 255, 0.14);
        border-top: 0;
        border-radius: 0 0 18px 18px;
        padding: 10px 106px;
        min-height: 64px;
        .navbar-header .header-logo img {
          width: 260px;
          height: 42px;
        }
        .navbar-nav > li > a {
          color: #fff;
          font-size: 15px;
        }
        .search-trigger {
          filter: brightness(0) invert(1);
        }
      }
      .navbar-header{
        flex-shrink: 0;
        z-index: 100;
        .header-logo{
          display: flex;
          align-items: center;
          img{
            width: 260px;
            height: 42px;
            object-fit: contain;
            display: block;
            transition: all 0.35s cubic-bezier(0.25, 0.1, 0.25, 1);
          }
        }
      }
      .header-right{
        display: flex;
        align-items: center;
        gap: 8px;
        z-index: 100;
        .navbar-nav{
          display: flex;
          align-items: center;
          margin: 0;
          padding: 0;
          &>li {
            display: block;
            margin: 0 10px;
            position: relative;
            &>a{
              display: block;
              font-size: 15px;
              font-weight: 600;
              color:#FFF;
              line-height: 38px;
              padding: 0 6px;
              text-align: center;
              white-space: nowrap;
              transition: color 0.25s;
            }
            .dropdown-menu{
              position: absolute;
              top: 100%;
              left: 50%;
              transform: translateX(-50%);
              z-index: 1000;
              display: none;
              font-size: 14px;
              text-align: left;
              list-style: none;
              border: none;
              min-width: 90px;
              border-radius: 0 0 var(--radius-sm) var(--radius-sm);
              padding: 4px 0 0 0;
              margin: 0;
              &>li{
                min-width: 90px;
                height: 30px;
                background: #ffffff;
                &:first-child { border-radius: var(--radius-sm) var(--radius-sm) 0 0; }
                &:last-child { border-radius: 0 0 var(--radius-sm) var(--radius-sm); }
                &>a{
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-bottom: none;
                  color: #333333;
                  margin:0;
                  padding: 6px 12px;
                  width: 100%;
                  height: 100%;
                  line-height: 1.2;
                  font-weight: 400;
                  text-align: center;
                  font-size: 12px;
                  white-space: nowrap;
                  transition: all 0.2s;
                  &:hover{
                    color: var(--primary);
                    background: rgba(10,109,194,.06);
                  }
                }
              }
            }
            &:hover .dropdown-menu{
              display: block;
            }
          }
        }
        .search-trigger {
            width: 18px;
            height: 18px;
            background: url('@/assets/icon11.png') no-repeat center center;
            background-size: 100% 100%;
            margin-left: 18px;
            cursor: pointer;
            opacity: 0.85;
            transition: opacity 0.25s, filter 0.35s;
            flex-shrink: 0;
            filter: brightness(0) invert(1);
            &:hover { opacity: 1; }
        }
        .toggle {
          display: none;
        }
      }
    }
  }
  .title{
    position:absolute;
    bottom:30px;
    z-index: 2;
    padding:0 106px;
    font-size:19px;
    color:#FFF;
    line-height:27px;
  }
}
</style>
